import React from 'react';


function CommunityArt(){
    return(
        <div>

        </div>
    );
}
export default CommunityArt;